import * as React from 'react'
import { useState } from 'react'
import { OnboardingComponentProps } from '.'
import { useLoadVGSForm } from '../../../hooks/useVGS'
import Button from '@doordash/component-button'
import { get } from 'lodash'
import { ssnFieldProps } from './styles'
import { useValidation } from '../../organisms/workflow-template/useValidation'

export const USBackgroundCheckVGSFormCollectComponent: React.FC<OnboardingComponentProps> = React.memo(
  ({
    templateResponseData,
    apiPath,
    label,
    data,
    target,
    onChange,
    onSubmitStep,
  }: OnboardingComponentProps) => {
    const [form] = useLoadVGSForm(data, ssnFieldProps)
    const [isLoading, setIsLoading] = useState(false)
    const { validateData } = useValidation()

    return (
      <Button
        state={isLoading ? Button.States.Loading : Button.States.Default}
        onClick={() => {
          const jsonData = get(templateResponseData, apiPath)
          const shouldShowStep2 = get(jsonData, target)
          // GBC requries user consent
          const isConsentExpired = get(jsonData, 'isConsentExpired')
          if (!validateData(templateResponseData)) {
            return
          }

          // hide disclosure if user consent is < 14 days
          // show disclosure if user consent is expired
          if (
            form.state.ssn.isValid &&
            (shouldShowStep2 || !isConsentExpired)
          ) {
            setIsLoading(true)
            onSubmitStep(templateResponseData, { form })
            return
          }

          // Hides form component, shows disclosure page with pii data
          if (
            form.state.ssn.isValid &&
            form.state.ssnConfirm.isValid &&
            !shouldShowStep2
          ) {
            return onChange({
              ...jsonData,
              ssn: `XXX-XX-${form.state.ssn.last4}`,
              [target]: true,
            })
          }

          onChange({
            ...jsonData,
            form,
          })
        }}
      >
        {label}
      </Button>
    )
  }
)
